import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { translate } from '../utils/translate';

interface DialogProps {
  shareNumber: number;
  visible: boolean;
  onConfirmed: () => void;
  onNotConfirmed: () => void;
}

const DeleteShareDialogComponent = (props: DialogProps) => {
  return (
    <div>
      <Dialog open={props.visible}>
        <DialogTitle>{translate('deleteShareDialog.title')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {translate('deleteShareDialog.question', { shareNumber: props.shareNumber })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onNotConfirmed} color="primary">
            {translate('confirmdialog.no')}
          </Button>
          <Button onClick={props.onConfirmed} color="primary" autoFocus={true}>
            {translate('confirmdialog.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteShareDialogComponent;
